
    var flktySub = new Flickity(  document.querySelector(".blog-inner-slider"), {
        contain:true,
         pageDots : false,
         adaptiveHeight: true,
         prevNextButtons: true,
        cellAlignment:"center",
         draggable:true,
         resize: false,
           autoPlay : false
       
       });

